<mat-card>
    <mat-card-content>
           <div class="state">
               <span>{{ maintenanceContext?.stateName }}</span>
           </div> 

            <div class="messages" *ngIf="maintenanceContext?.messages?.length > 0">
                <div class="span-container" *ngFor="let message of maintenanceContext?.messages">
                    <span class="message">
                        {{ message }}
                    </span>
                </div>
            </div>

            <div class="inputs" *ngIf="maintenanceContext?.commands?.length > 0">
                <div *ngFor="let command of maintenanceContext?.commands">
                    <div *ngFor="let fieldDefItem of command?.fieldDef">
                        <app-maintenance-test-command-input [fieldDefItem]="fieldDefItem"></app-maintenance-test-command-input>
                    </div>
                </div>
            </div>

            <div class="commands" *ngIf="maintenanceContext?.commands?.length > 0">
                <button *ngFor="let command of maintenanceContext?.commands" 
                    mat-raised-button color="primary" class="command" data-cy="test-command"
                    [disabled]="buttonDisabled"
                    (click)="triggerTestCommand(command)">
                    {{ command.text }}
                </button>
            </div>

            <div class="commands back" *ngIf="maintenanceContext?.inSelectionMenu">
                <button 
                    mat-raised-button color="primary"
                    class="command"
                    data-cy="back-command"
                    [disabled]="buttonDisabled"
                    (click)="triggerTestBackCommand()">
                    Back   
                </button>
            </div>
    </mat-card-content>
</mat-card>